import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"delete\"><defs><style>#delete .cls-1{fill:#fff}#delete .cls-2{fill:#8c8c8c;stroke:rgba(255,255,255,0);fill-rule:evenodd}</style></defs><g id=\"delete_组_2695\" data-name=\"组 2695\" transform=\"translate(-1045 -162)\"><circle id=\"delete_椭圆_35\" data-name=\"椭圆 35\" class=\"cls-1\" cx=\"5\" cy=\"5\" r=\"5\" transform=\"translate(1045 162)\" /><path id=\"delete_路径_1182\" data-name=\"路径 1182\" class=\"cls-2\" d=\"M677 738a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm1.729 5.3a.306.306 0 0 1-.432.432l-1.3-1.3-1.3 1.3a.306.306 0 0 1-.432-.432l1.3-1.3-1.3-1.3a.306.306 0 0 1 .432-.432l1.3 1.3 1.3-1.3a.306.306 0 0 1 .432.432l-1.3 1.3z\" transform=\"translate(373 -575)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/delete.svg
// module id = ZEWN
// module chunks = 6